import type { RouteObject } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import { AuthModalProvider } from '@/contexts/AuthModalContext'
import { MessagesProvider } from '@/contexts/MessagesContext'
import Dashboard from '@/pages/Dashboard'
import Discover from '@/pages/Discover'
import Feed from '@/pages/Feed'
import Home from '@/pages/Home'
import MessageThread from '@/pages/MessageThread'
import Messages from '@/pages/Messages'
import Pricing from '@/pages/Pricing'
import Search from '@/pages/Search'
import Store from '@/pages/Store'
import { useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { path: '', element: <Home /> },
      { path: 'pricing', element: <Pricing /> },
      { path: 'feed', element: <Feed /> },
      { path: 'discover', element: <Discover /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'messages', element: <Messages /> },
      { path: 'messages/:peerId', element: <MessageThread /> },
      { path: 'search', element: <Search /> },
      { path: 'store/:userId', element: <Store /> },
      { path: ':storeSlug', element: <Store /> },
    ],
  },
]

function App() {
  const element = useRoutes(routes)
  return (
    <AuthModalProvider>
      <MessagesProvider>{element}</MessagesProvider>
    </AuthModalProvider>
  )
}

export default App
